import type { DroneMaintenanceAdjustType } from '@src/features/fleet/redux/types';

export type Motor = 'motor';
export type Propeller = 'propeller';
export type RuntimeItemType = Motor | Propeller;

export interface RuntimeItem {
  name: string;
  hoursLabel: string;
  progressValue: number;
  type: RuntimeItemType;
}

export type AdjustType = 'runtime' | 'serviceLimit';

export const ADJUST_TYPE_TO_API: Record<AdjustType, DroneMaintenanceAdjustType> = {
  runtime: 'RUNTIME',
  serviceLimit: 'LIMIT',
};

export interface AdjustPopupProps {
  type: AdjustType;
  value: number;
  open: boolean;
  onClose: () => void;
  onSave: (value: number) => void;
  onValueChange: (value: number) => void;
}